<template>
  <div class="Exam-login-Outer">
    <div class="Exam-login-Inner">
      <div class="login-Padding">
      </div>
      <div class="login-Header">
        <p>Log in</p>
      </div>
      <div class="login-Padding">
      </div>
      <div class="login-message">
        <form v-on:submit.prevent.stop="handleLoginSubmit">
          <div class="form-label">
            <p>User Name</p>
          </div>
          <input type="text" v-model.trim="userName"/><br/>
          <div class="form-label">
            <p>Password</p>
          </div>
          <input type="password" v-model.trim="userPasswd"/><br/>
          <div class="form-label">
            <p>Institution</p>
          </div>
          <input type="text" v-model.trim="instituteCode"/><br/>
          <div class="form-label">
            <p>Exam Code</p>
          </div>
          <input type="text" v-model.trim="userExamCode" ref="ExamCodeRef"/><br/>
          <div class="login-button-box">
            <button type="submit">LOG IN</button>
          </div>
        </form>
      </div>
      <MessageDisplay v-if="isRespMsg" :MType="msgType" :mmsg="vLoginResponse" />
      <MessageDisplay v-if="isErrorMsg" :MType="msgType" :mmsg="vconnectError" />
    </div>
  </div>
</template>

<script>
import MessageDisplay from '@/components/MessageDisplay.vue'
var localip = require('quick-local-ip')
export default {
  name: 'HomeLogon',
  props: ['server'],
  components: {MessageDisplay},
  data () {
    return {
      userName: '',
      userPasswd: '',
      userExamCode: '',
      isErrorMsg: false,
      isRespMsg: false,
      vLoginResponse: '',
      vconnectError: '',
      ExamDetails: '',
      msgType: '',
      instituteCode: ''
    }
  },
  methods: {
    handleLoginSubmit: function () {
      if ((this.userExamCode !== '') && (this.userName !== '') && (this.userPasswd !== '') && (this.instituteCode !== '')) {
        if (this.validateFormValues()) {
          this.$store.commit('onSpinner')
          this.isRespMsg = false
          this.isErrorMsg = false
          const url = this.server.htp + '://' + this.server.IP + ':' + this.server.Port + this.server.Webapp + 'login'
          console.log('LoginURL :', url)
          const vform = {
            username: this.userName,
            password: this.userPasswd,
            instcode: this.instituteCode
          }
          fetch(url, {
            mode: 'cors',
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            body: JSON.stringify(vform)
          }).then((response) => {
            this.$store.commit('offSpinner')
            if (response.status === 200) {
              response.json().then(jsonresp => {
                this.$store.commit('successFulLogin', {
                  token: jsonresp.token,
                  username: this.userName
                })
                this.handleLoginAccess()
              })
            } else if (response.status === 401) {
              this.vLoginResponse = 'Wrong Login Credentials'
              this.isRespMsg = true
              this.msgType = 'MSG'
            } else if (response.status === 403) {
              this.vLoginResponse = 'Access Denied!!!'
              this.isRespMsg = true
              this.msgType = 'MSG'
            } else {
              this.vconnectError = 'Login Error!!!'
              this.isErrorMsg = true
              this.msgType = 'ERR'
            }
          }).catch(error => {
            console.log('LoginError : ', error)
            this.$store.commit('offSpinner')
            this.vconnectError = 'Connection Error!!!'
            this.isErrorMsg = true
            this.msgType = 'ERR'
          })
        }
      }
    },
    handleLoginAccess: function () {
      this.$store.commit('onSpinner')
      this.isRespMsg = false
      this.isErrorMsg = false
      this.ExamDetails = ''
      const url = this.server.htp + '://' + this.server.IP + ':' + this.server.Port + this.server.Webapp + 'home'
      const LocIP = localip.getLocalIP4() + '-' + localip.getLocalIP6()
      console.log('LoginURL :', url)
      var formData = new FormData()
      formData.append('userIP', LocIP)
      formData.append('examcode', this.userExamCode)
      fetch(url, {
        mode: 'cors',
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + this.$store.state.auth.token
        },
        body: formData
      }).then(res => {
        this.httpStatus = res.status
        return res.json()
      }).then(response => {
        console.log('LoginResponse :', response)
        this.ExamDetails = response
        this.$store.commit('offSpinner')
        if (this.httpStatus === 403) {
          this.vLoginResponse = 'Access to Resource is Denied'
          this.isRespMsg = true
          this.msgType = 'MSG'
        } else if ((this.ExamDetails.Response !== undefined) && (this.ExamDetails.Response.includes('Success'))) {
          this.SuccessFull()
        } else {
          if (this.ExamDetails.Response === undefined) {
            this.vconnectError = 'Login Error!!!'
            this.isErrorMsg = true
            this.msgType = 'ERR'
          } else {
            this.vLoginResponse = this.ExamDetails.Response
            this.isRespMsg = true
            this.msgType = 'MSG'
          }
        }
      })
        .catch(error => {
          console.log('LoginError :', error)
          this.$store.commit('offSpinner')
          this.vconnectError = 'Connection Error!!!'
          this.isErrorMsg = true
          this.msgType = 'ERR'
        })
    },
    validateFormValues () {
      if ((this.userExamCode === null) || (this.userExamCode === '')) {
        alert(`Exam Code Field cannot be blank`)
        this.refs.ExamCodeRef.focus()
        return false
      }
      if ((this.userExamCode.split('-') < 2) || (this.userExamCode.split('-') > 2)) {
        alert(`Exam Code Field must have an hyphen`)
        this.refs.ExamCodeRef.focus()
        return false
      }
      return true
    },
    SuccessFull () {
      this.$emit('LogSuccess', this.ExamDetails, this.userExamCode, this.instituteCode, this.userName)
    }
  }
}
</script>

<style scoped>
.Exam-login-Outer{
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column;
  justify-content: center;
}
.Exam-login-Inner {
  width: 250px;
}
.login-Header {
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #666666;
}
.login-Header p{
  font-size: 38px;
  margin-top: 0;
  margin-bottom: 0;
}

.login-Padding {
  height: 30px;
}
@media screen and (max-width:414px) {
  .login-Padding {
    height: 10px;
  }
}
.login-message {
  border-style: solid;
  border-width: 5px;
  border-color: lightgrey;
  padding-left: 10px;
  border-radius: 20px;
}
.login-message .form-label{
  width:100px;
  height:20px;
}
.login-button-box {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height:70px;
  width:100%;
}
.login-button-box button{
  background-color: #395693;
  border-radius: 20px;
  height:40px;
  width:100px;
  color: white;
  font-size:15px;
  outline-style: none;
}
.login-message input{
  padding-left: 10px;
  min-width:150px;
  height:25px;
  border-radius: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeLogon.vue